import { HttpClient } from '@angular/common/http';
import { firstValueFrom, map } from 'rxjs';
import { GoogleLoginProvider } from '@abacritt/angularx-social-login';
import { providerInfo, resolveGoogleLoginMode } from './google-id-token.service';

/**
 * Social-login config for `@abacritt/angularx-social-login`. In relay mode (app#397) NO provider is
 * registered: the Google Identity Services script is never loaded on a host that is not an
 * authorized JS origin — the relay button is a plain button, and `SocialAuthService.signOut` on
 * logout rejects harmlessly, as it already does after a password login.
 */
export const loadSocialAuthConfig = async (http: HttpClient, hostname: string = window.location.hostname) =>
  firstValueFrom(
    providerInfo(http).pipe(
      map((info) => ({
        autoLogin: false,
        lang: 'en',
        providers:
          resolveGoogleLoginMode(info, hostname) === 'relay'
            ? []
            : [
                {
                  id: GoogleLoginProvider.PROVIDER_ID,
                  provider: new GoogleLoginProvider(info.googleClientId, {
                    oneTapEnabled: false,
                  }),
                },
              ],
        onError: (err: any) => console.error(err),
      }))
    )
  );
